import { ensureCsrfTokenForArgs, rtkPrepareHeadersCallback } from '@Api/Api'
import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/dist/query/react'
import { UserProgress, UserProgressPayload } from './Progress.types'

const progressFetchBaseQuery = fetchBaseQuery({
	baseUrl: `${process.env.REACT_APP_API_BASE_URL}/student/progress/`,
	prepareHeaders: rtkPrepareHeadersCallback,
	// STILL no 401 handling on this root: a terminal 401 here neither logs out
	// nor redirects (BaseApi's interceptor does both). Survivable only because
	// every page that fires this query also fires BaseApi queries that do the
	// job — worth folding into a shared wrapper if this root ever grows.
	credentials: 'include',
})

// Its one endpoint is a POST declared as `builder.query`, so it needs the CSRF
// token like any mutation; the method check keeps any future GET here fast.
const progressBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
	await ensureCsrfTokenForArgs(args)
	return progressFetchBaseQuery(args, api, extraOptions)
}

export const ProgressAPI = createApi({
	reducerPath: 'ProgressAPI',
	baseQuery: progressBaseQuery,
	endpoints: builder => ({
		getAllClassroomsProgress: builder.query<ApiResponse<UserProgress>, UserProgressPayload>({
			query: (info: UserProgressPayload) => {
				return {
					url: '',
					method: 'POST',
					body: info,
				}
			},
		}),
	}),
})

export const { useGetAllClassroomsProgressQuery } = ProgressAPI
